import { Routes } from "@angular/router";
import { CountryListComponent } from './country/country-list/country-list.component';
import { CountryDetailComponent } from './country/country-add-edit/country-addedit.component';
import { HomeComponent } from './home/home.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { RuleListComponent } from './rules/rule-list/rule-list.component';
import { RuleAddEditComponent } from './rules/rule-add-edit/rule-addedit.component';
import { FAQListComponent } from './faq/faq-list/faq-list.component';
import { FAQAddEditComponent } from './faq/faq-add-edit/faq-addedit.component';
import { TermsListComponent } from './terms/terms-list/terms-list.component';
import { TermsAddEditComponent } from './terms/terms-add-edit/terms-addedit.component';
import { LoginComponent } from './user/login/login.component';
import { AuthGuard } from './auth/auth.guard';
import { ChangePasswordComponent } from './user/profile/changepassword.component';
import { PrivacyComponent } from './privacy/privacy-policy/privacy-policy.component';
import { ConditionsComponent } from './termsandconditions/termsandconditions/termsandconditions.component';
import { CommentListComponent } from './comment/comment-list/comment-list.component';
export const ROUTES: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '', component: MainLayoutComponent,
    children: [
      { path: 'country-list', component: CountryListComponent, canActivate: [AuthGuard] },
      { path: 'country-addedit/:id', component: CountryDetailComponent, canActivate: [AuthGuard] },
      { path: 'country-addedit', component: CountryDetailComponent, canActivate: [AuthGuard] },
      { path: '', component: HomeComponent},
      { path: 'rule-list', component: RuleListComponent, canActivate: [AuthGuard] },
      { path: 'rule-addedit/:id', component: RuleAddEditComponent, canActivate: [AuthGuard] },
      { path: 'rule-addedit', component: RuleAddEditComponent, canActivate: [AuthGuard] },
      { path: 'faq-list', component: FAQListComponent, canActivate: [AuthGuard] },
      { path: 'faq-addedit/:id', component: FAQAddEditComponent, canActivate: [AuthGuard] },
      { path: 'faq-addedit', component: FAQAddEditComponent, canActivate: [AuthGuard] },
      { path: 'terms-list', component: TermsListComponent, canActivate: [AuthGuard] },
      { path: 'terms-addedit/:id', component: TermsAddEditComponent, canActivate: [AuthGuard] },
      { path: 'terms-addedit', component: TermsAddEditComponent, canActivate: [AuthGuard] },
      { path: 'changepassword', component: ChangePasswordComponent, canActivate: [AuthGuard] },
      { path: 'comments', component: CommentListComponent, canActivate: [AuthGuard] },
      { path: 'privacy', component: PrivacyComponent },
      { path: 'termsandconditions', component: ConditionsComponent }

    ]
  },
  //{ path: '401', component: UnauthorizedComponent }
]
